import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { IOutlet } from "../../store/outlet/types";
import { setFilterOutlets } from "../../store/filter/actions";
import { setInsightsStoriesOpen } from "../../store/insights/actions";
import { getAllOutlets, getLoadingOutlets } from "../../store/outlet/selectors";
import { getFilter } from "../../store/filter/selectors";
import useContent from "../../hooks/useContent";
import OutletReview from "./OutletReview";
import RecentSales from "./RecentSales";
import TargetCard from "./target/TargetCard";
import ProductInfo from "./ProductInfo";
import KegsInfo from "./KegsInfo";
import InsightCardList from "./InsightCardList";
import styles from "./overview.module.scss";

export const Overview: React.FC<RouteComponentProps> = ({ location, match }) => {
  const dispatch = useDispatch();
  const [isUnknownOutlet, setIsUnknownOutlet] = useState(false);
  const filter = useSelector(getFilter);
  const outlets = useSelector(getAllOutlets);
  const isLoadingOutlets = useSelector(getLoadingOutlets);
  const { managerAppOverview: content } = useContent();

  useEffect(() => {
    // eslint-disable-next-line prefer-destructuring
    const params: any = match.params;

    if (params.id && outlets && filter) {
      if (!filter.outlets.find(d => d.id === params.id)) {
        const selectedOutlet = outlets.find((d: IOutlet) => d.id === params.id);
        if (selectedOutlet) {
          dispatch(setFilterOutlets([selectedOutlet]));
        }
        setIsUnknownOutlet(!selectedOutlet);
      }
    }
  }, [dispatch, location, filter, outlets, match.params, match]);

  useEffect(() => {
    // @ts-ignore
    if (location.state?.insightId) {
      dispatch(
        setInsightsStoriesOpen({
          // @ts-ignore
          id: location.state?.insightId,
          // @ts-ignore
          locationId: location.state?.insightOutletId
        })
      );
    }
  }, []);

  return content && isUnknownOutlet ? (
    <h2 className={styles.overviewUnknownOutlet}>{content.manager_app_overview_unknown_outlet}</h2>
  ) : !isLoadingOutlets && !outlets.length ? (
    <h2 className={styles.overviewUnknownOutlet}>{content.manager_app_overview_empty}</h2>
  ) : (
    <div className={styles["overview-page"]}>
      <InsightCardList />
      {(filter.outlets[0]?.type || filter.outlets.length === 0) && (
        <OutletReview noLoading id="outlet_review" lazy={false} />
      )}
      <div className={styles.recentSalesTargetWrapper}>
        <RecentSales />
        <TargetCard id="monthly_target" />
      </div>
      <ProductInfo />
      {outlets[0] && <KegsInfo />}
    </div>
  );
};

export default connect(null)(withRouter(Overview));
